export class SectionTypes {
  DESCRIPTION = 'description';
  GENERIC_GRAPH_BAR = 'generic_graph';
  PROFILE = 'profile';
  DIMENSION = 'dimension';
}
